<form (submit)="onMfaCodeSubmit()" class="flex flex-col space-y-3">
	<div class="flex flex-col space-y-1">
		<span class="font-semibold">
			{{ 'presentation.app.common.dialog.mfa-engage.qrcode' | translate }}
		</span>
		<img
			[alt]="mfaEngage.secret"
			[src]="mfaEngage.qrCodeImageUri"
			class="w-64 h-64 self-center"
		/>
	</div>
	<div class="flex flex-col space-y-1">
		<span class="font-semibold">
			{{ 'presentation.app.common.dialog.mfa-engage.manual' | translate }}
		</span>
		<div class="flex items-center space-x-1">
			<label class="flex-none w-32">
				{{ 'presentation.app.common.dialog.mfa-engage.secret' | translate }}
			</label>
			<span class="flex-1 break-all">{{ mfaEngage.secret }}</span>
		</div>
		<div class="flex items-center space-x-1">
			<label class="flex-none w-32">
				{{ 'presentation.app.common.dialog.mfa-engage.account' | translate }}
			</label>
			<span class="flex-1">{{ mfaEngage.account }}</span>
		</div>
		<div class="flex items-center space-x-1">
			<label class="flex-none w-32">
				{{ 'presentation.app.common.dialog.mfa-engage.issuer' | translate }}
			</label>
			<span class="flex-1">{{ mfaEngage.issuer }}</span>
		</div>
	</div>
	<div
		class="
			flex
			md:flex-row md:space-x-1 md:space-y-0
			flex-col
			space-y-3
			md:items-center
		"
	>
		<label class="flex-none">
			{{ 'presentation.app.common.dialog.mfa-engage.code.label' | translate }}
		</label>
		<p-inputMask
			[ngModelOptions]="{ standalone: true }"
			[placeholder]="
				'presentation.app.common.dialog.mfa-engage.code.placeHolder' | translate
			"
			[unmask]="true"
			[(ngModel)]="mfaCode"
			class="flex-1"
			mask="999-999"
			styleClass="w-full"
		></p-inputMask>
	</div>
	<p-progressSpinner
		*ngIf="controller.isSaving$ | async; else validate"
		[style]="{ width: '30px', height: '30px' }"
		class="self-center"
	></p-progressSpinner>
	<ng-template #validate>
		<button
			[disabled]="isMfaCodeInvalid()"
			[label]="
				'presentation.app.common.dialog.mfa-engage.validate.label' | translate
			"
			pButton
			type="submit"
		></button>
	</ng-template>
</form>
